var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"action-status-select",on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},_vm._l((_vm.sortedStatuses),function(actionStatus){return _c('option',{key:actionStatus.id,domProps:{"value":actionStatus.id,"selected":actionStatus.id === _vm.value}},[_vm._v(" "+_vm._s(actionStatus.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }